module.exports = __webpack_public_path__ + "media/images/common/shop/icon-clock-20527298a4bc82faaa1b972ebe651262.png";